'use strict'

import vars from '@/vars'

let var__pc = vars.uaset.pc
let arrayBound, tgtArea, map

$(function(){
  if( $("body").is(".rec-course") ){

    if( $("#map__body").length > 0 ){
      map = new GMaps({
        div: '#map__body',
        lat: 35.280862,
        lng: 136.114291,
        zoom: 12,
        panControl: false,
        mapTypeControl: false,
        zoomControl: false,
        scrollwheel: false,
        // scaleControl: boolean,
        streetViewControl: false,
        overviewMapControl: false,

      });

      var $map = map.map;
      var arrayBound;

      $.fn.extend({

        // 該当エリアのモデルコースを作成
        //------------------------------------------------------------
        spotLoad: function(options){
          var arrayBound = [];
          tgtArea = options.area;

          $.ajax({
            url: '/design/json/cource.json',
            success: function(data){
              $(data).each(function(i){

                if( this.area == tgtArea ){
                  //

                  if(this.mode == "driving" || this.mode == "walking" ){
                    var next = Number(i + 1);
                    var nextPost = data[next];
                    var $mode = this.mode;

                    map.drawRoute({
                      origin: [Number(this.lat), Number(this.lng)],
                      destination: [Number(nextPost.lat), Number(nextPost.lng)],
                      travelMode: this.mode,
                      strokeColor: '#ed2a78',
                      strokeOpacity: 0.7,
                      strokeWeight: 3,

                      callback: function(e){



                        var path = e.overview_path;
                        var center = path.length / 2;
                        center = center.round();
                        center = path[center];
                        // center = center.round();

                        var time = e.legs[0].duration.text;
                        var distance = e.legs[0].distance.text;

                        var view = $("#view__distance").html();
                        var elm = $('<div>'+ view +'</div>');

                        if( $mode == "walking" ){
                          $(".map__distance__icon", elm).addClass("is-walking");
                        }

                        $(".distance", elm).text(distance);
                        $(".time", elm).text(time);

                        // routeの中心点に距離などを表示
                        //------------------------------------------------------------
                        map.drawOverlay({
                          lat: center.lat(),
                          lng: center.lng(),
                          layer: 'overlayMouseTarget',
                          content: elm.html(),
                          verticalAlign: 'middle',
                          horizontalAlign: 'center',

                          // click: function(){
                          //   var el = $(this.el);
                          //   var lat = $(".map__marker", this.el).attr("data-lat");
                          //   var lng = $(".map__marker", this.el).attr("data-lng");
                          //   $(".gmap__div").removeClass("is-active");
                          //   el.addClass('is-active');
                          // },

                          mouseover:function(){
                            var el = $(this.el);
                            el.addClass("is-hover");
                          },

                          mouseout: function(){
                            var el = $(this.el);
                            el.removeClass("is-hover");
                          }
                        });
                      }
                    });
                  }

                  // pinのview
                  //------------------------------------------------------------
                  var view = $("#view__marker").html();
                  var elm = $('<div>'+ view +'</div>');

                  // domの操作
                  $(".map__marker__info__photo img", elm).attr("src", "/" + this.img);

                  $(".map__marker", elm).attr("data-lat", this.lat);
                  $(".map__marker", elm).attr("data-lng", this.lng);

                  if( this.order !== "null"){
                    $(".map__marker__circle", elm).text(this.order);
                    $(".map__marker__circle", elm).addClass("is-active");
                  }



                  if(this.url){
                    $(".map__marker__info a", elm)
                      .attr("href", this.url)
                      .attr("target", "_blank");
                  } else{
                    $(".map__marker__info a", elm).attr("href", "http://www.biwako-visitors.jp/spot/detail/" + this.spot_id);
                  }

                  $(".map__marker__info__title", elm).text(this.title);
                  $(".map__marker__info__subtitle", elm).text(this.subtitle);

                  // latARR.push( Number(this.lat) );
                  // lngARR.push( Number(this.lng) );

                  var item  = new google.maps.LatLng( Number(this.lat), Number(this.lng));
                  arrayBound.push(item);

                  map.drawOverlay({
                    lat: Number(this.lat),
                    lng: Number(this.lng),
                    layer: 'overlayMouseTarget',
                    content: elm.html(),
                    verticalAlign: 'middle',
                    horizontalAlign: 'center',

                    click: function(ev){
                      var el = $(this.el);
                      var lat = $(".map__marker", this.el).attr("data-lat");
                      var lng = $(".map__marker", this.el).attr("data-lng");


                      if( $("html").is(".is-active") ){

                      } else{
                        map.panTo({
                          lat: Number(lat),
                          lng: Number(lng)
                        });
                      }

                      $(".gmap__div").removeClass("is-active");
                      el.addClass("is-active");
                    },

                    mouseover:function(){
                      if( $("html").is(var__pc) ){
                        var el = $(this.el);
                        el.addClass("is-hover");
                      }
                    },

                    mouseout: function(){
                      if( $("html").is(var__pc) ){
                        var el = $(this.el);
                        el.removeClass("is-hover");
                      }

                    }
                  });
                }

              });

              map.fitLatLngBounds( arrayBound );
            }
          });

          $(".map__controls__reload").on('click', function(){
            map.fitLatLngBounds( arrayBound );
          });
        },

        spotLoadAll: function(){
          var arrayBound = [];

          $.ajax({
            url: '/design/json/cource.json',
            success: function(data){
              $(data).each(function(i){

                // pinのview
                //------------------------------------------------------------
                var view = $("#view__marker").html();
                var elm = $('<div>'+ view +'</div>');

                $(".map__marker__info__photo img", elm).attr("src", "/" + this.img);

                $(".map__marker__circle", elm).addClass("type-" + this.type);
                $(".map__marker", elm).attr("data-lat", this.lat);
                $(".map__marker", elm).attr("data-lng", this.lng);

                if( this.order !== "null"){
                  // $(".map__marker__circle", elm).text(this.order);
                  // $(".map__marker__circle", elm).addClass("is-active");
                }



                if(this.url){
                  $(".map__marker__info a", elm)
                    .attr("href", this.url)
                    .attr("target", "_blank");
                } else{
                  $(".map__marker__info a", elm).attr("href", "http://www.biwako-visitors.jp/spot/detail/" + this.spot_id);
                }

                $(".map__marker__info__title", elm).text(this.title);
                $(".map__marker__info__subtitle", elm).text(this.subtitle);

                var item  = new google.maps.LatLng( Number(this.lat), Number(this.lng));
                arrayBound.push(item);

                map.drawOverlay({
                  lat: Number(this.lat),
                  lng: Number(this.lng),
                  layer: 'overlayMouseTarget',
                  content: elm.html(),
                  verticalAlign: 'middle',
                  horizontalAlign: 'center',

                  click: function(ev){
                    var el = $(this.el);
                    var lat = $(".map__marker", this.el).attr("data-lat");
                    var lng = $(".map__marker", this.el).attr("data-lng");

                    if( $("html").is(".is-active") ){

                    } else{
                      map.panTo({
                        lat: Number(lat),
                        lng: Number(lng)
                      });
                    }

                    $(".gmap__div").removeClass("is-active");
                    el.addClass("is-active");

                  },

                  mouseover:function(){
                    if( $("html").is(var__pc) ){
                      var el = $(this.el);
                      el.addClass("is-hover");
                    }
                  },

                  mouseout: function(){
                    if( $("html").is(var__pc) ){
                      var el = $(this.el);
                      el.removeClass("is-hover");
                    }

                  }
                });

              });

              map.fitLatLngBounds( arrayBound );
            }
          });

          $(".map__controls__reload").on('click', function(){
            map.fitLatLngBounds( arrayBound );
          });


        }
      });

      // // tile system
      // //------------------------------------------------------------
      // var mapDesign = "high-contrast";
      // var token = "?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6IlhHVkZmaW8ifQ.hAMX5hSW-QnTeRCMAy9A8Q";
      // // var tile = "//c.tile.stamen.com/watercolor/";
      // var tile = "//c.tile.thunderforest.com/transport/";
      // // var tile = "//c.tile.openstreetmap.org/";

      // map.addMapType("osm", {
      //   getTileUrl: function(coord, zoom) {
      //     // return "https://a.tiles.mapbox.com/v4/mapbox.streets-basic/" + zoom + "/" + coord.x + "/" + coord.y + ".png" + token;
      //     return tile + zoom + "/" + coord.x + "/" + coord.y + ".png" + token;
      //   },
      //   tileSize: new google.maps.Size(256, 256),
      //   name: "OpenStreetMap",
      //   maxZoom: 18
      // });
      // map.setMapTypeId("osm");


      // google style map
      //------------------------------------------------------------
      var styles = [
        {
          "featureType": "administrative.country",
          "stylers": [
            { "visibility": "simplified" }
          ]
        },
        // {
        //   "featureType": "road",
        //   "stylers": [
        //     { "visibility": "simplified" },
        //     // { "gamma": 1 },
        //     { "saturation": -40 },
        //     { "lightness": 20 },
        //     { "hue": "#006633" }
        //   ]
        // },
        {
          "featureType": "poi",
          "stylers": [
            { "visibility": "off" }
          ]
        },
        // {
        //   "featureType": "landscape",
        //   "stylers": [
        //     { "visibility": "off" }
        //   ]
        // },
        {
          "featureType": "water",
          "stylers": [
            { "hue": "#2f97dd" }
          ]
        }
        // {
        //   "stylers": [
        //     { "gamma": 0.97 }
        //   ]
        // }
      ];
      map.addStyle({
          styledMapName:"Styled Map",
          styles: styles,
          mapTypeId: "map_style"
      });

      map.setStyle("map_style");

      // controls
      var controls = $("#view__controls").html();
      $("#map__body").before(controls);

      $(".map__marker__info__close").live('click', function(){
        var that = $(this).parents().filter(".gmap__div");
        that.removeClass('is-active');
        that.removeClass('is-hover');
      });

      $(".map__controls__zoom-in").on('click', function(){
        var level = $map.getZoom();
        level ++;
        $map.setZoom(level);
      });

      $(".map__controls__zoom-out").on('click', function(){
        var level = $map.getZoom();
        level --;
        $map.setZoom(level);
      });

    }
  }
});



// WEBPACK FOOTER //
// ./_src/js/cont/rec-course-map.js